import { useSetting } from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { FE_LISP_PREFETCH_DEBOUNCE_250916 } from "@faire/retailer-settings/FE_LISP_PREFETCH_DEBOUNCE_250916";

export const useSettingLispPrefetchDebounce = () =>
  useSetting(FE_LISP_PREFETCH_DEBOUNCE_250916);
